import { render } from "./BCardModal.vue?vue&type=template&id=630e79a3&scoped=true&ts=true"
import script from "./BCardModal.vue?vue&type=script&lang=ts"
export * from "./BCardModal.vue?vue&type=script&lang=ts"

import "./BCardModal.vue?vue&type=style&index=0&id=630e79a3&scoped=true&lang=css"

import exportComponent from "/Users/malo/Documents/lamasign/be-right-vue3-lib 15.25.31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630e79a3"]])

export default __exports__